module.exports = __webpack_public_path__ + "static/media/49.4e0fd82f.png";